module.exports = __webpack_public_path__ + "static/breeze-4e041928e6aa5ff422a5b49bf8e2cfb3.svg";